import {ChangeDetectionStrategy, Component} from '@angular/core';

/**
 * @ngModule DisplaysModule
 */
@Component({
  selector: 'maia-avatar-display',
  templateUrl: './avatar-display.component.html',
  styleUrls: ['./avatar-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarDisplayComponent {}
